<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <!-- Título y subtítulo -->
      <v-row justify="start" align="start" class="ma-0 mb-4 mt-5">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: black;">
            Historial de cobros recibidos
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            Aquí puedes consultar todos los cobros recibidos.
          </div>
        </v-col>
      </v-row>

      <!-- Buscador y botón de descarga -->
      <v-row class="ma-0 mb-4" style="align-items: center;">
        <v-col cols="12" sm="4" md="2" lg="3" class="pl-0">
          <v-text-field
            v-model="search"
            min-width="288"
            max-width="288"
            label="Buscar"
            hide-details
            append-icon="mdi-magnify"
            outlined
            style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;"
          />
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn
            color="black"
            elevation="8"
            class="white--text"
            style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
            @click="descargarExcel"
          >
            <v-img
              class="mr-2"
              src="@/assets/icons/Vector.svg"
              style="width: 14px;"
            />
            Descargar
          </v-btn>
        </v-col>
      </v-row>

      <!-- Tabla desktop -->
      <v-data-table
        class="d-none d-sm-block"
        :headers="headers"
        :items="paymentsCedente"
        :search="search"
        hide-default-header
      >
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">ID</th>
              <th class="header__title center">Fecha</th>
              <th class="header__title center">Cliente</th>
              <th class="header__title center">Monto</th>
              <th class="header__title center">Origen</th>
              <th class="header__title center">Destino</th>
              <th class="header__title right">Acciones</th>
            </tr>
          </thead>
        </template>

        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.id }}</td>
              <td class="table__item">{{ formatDate(item.fecha) }}</td>
              <td class="table__item">{{ item.debtor }}</td>
              <td class="table__item">${{ formatMoney(item.amount) }} USD</td>
              <td class="table__item">{{ item.origin }}</td>
              <td class="table__item">{{ item.destination }}</td>
              <td class="table__item">
                <v-btn icon color="black">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-btn icon color="black" @click="descargarComprobante(item)">
                  <v-icon>mdi-file-download-outline</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <!-- Tabla móvil -->
      <v-data-table class="d-sm-none d-block" :items="paymentsCedente" hide-default-header>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id" style="display: flex; flex-direction: column;">
              <td class="table__item__mobile"><strong>ID:</strong> {{ item.id }}</td>
              <td class="table__item__mobile"><strong>Fecha:</strong> {{ formatDate(item.fecha) }}</td>
              <td class="table__item__mobile"><strong>Cliente:</strong> {{ item.debtor }}</td>
              <td class="table__item__mobile"><strong>Monto:</strong> ${{ formatMoney(item.amount) }} USD</td>
              <td class="table__item__mobile"><strong>Origen:</strong> {{ item.origin }}</td>
              <td class="table__item__mobile"><strong>Destino:</strong> {{ item.destination }}</td>
              <td class="table__item__mobile">
                <v-btn icon small @click="descargarComprobante(item)">
                  <v-icon>mdi-file-download-outline</v-icon>
                </v-btn>
              </td>
              <v-divider></v-divider>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import moment from "moment"; 
export default {
  data() {
    return {
      search: "",
      paymentsCedente: [],
      headers: []
    };
  },
  methods: {
    async getPayments() {
      try {
        this.isLoading = true;
        const response = await DB.get(`${URI}/api/v1/en/paymentsDebtor/`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.paymentsCedente = response.data.payments;
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    formatMoney(value) {
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    descargarExcel() {
      console.log("Descargando Excel...");
    },
    descargarComprobante(pago) {
      console.log("Descargar comprobante de", pago.id);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
  },
  beforeMount() {
    this.getPayments();
  }
};
</script>

<style scoped>
.header__title {
  font-family: 'montserrat-semibold';
  font-size: 13px;
  padding: 12px;
}
.header__title.left {
  text-align: left;
}
.header__title.center {
  text-align: center;
}
.header__title.right {
  text-align: right;
}
</style>
